import { Box } from "lucide-react";

export const Footer = () => {
  return (
    <footer className="bg-[#0A0A0A] text-white" data-testid="site-footer">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 lg:px-16 pt-20 pb-12">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-8">
          <div className="md:col-span-5">
            <div className="flex items-center gap-2 mb-5">
              <div className="w-8 h-8 bg-[#FF4F00] flex items-center justify-center">
                <Box className="w-5 h-5" strokeWidth={2.5} />
              </div>
              <span className="font-display font-bold text-xl">TOTEHAUL</span>
            </div>
            <p className="text-neutral-400 max-w-sm leading-relaxed">
              Reusable moving totes delivered to your door. Pack smarter. Move
              greener. Stress less.
            </p>
          </div>

          <div className="md:col-span-2">
            <p className="text-xs tracking-[0.2em] uppercase text-neutral-500 mb-4">Service</p>
            <ul className="space-y-2 text-neutral-300 text-sm">
              <li><a href="#tiers" className="hover:text-[#FF4F00]">Tiers</a></li>
              <li><a href="#how" className="hover:text-[#FF4F00]">How it works</a></li>
              <li><a href="#faq" className="hover:text-[#FF4F00]">FAQ</a></li>
            </ul>
          </div>

          <div className="md:col-span-2">
            <p className="text-xs tracking-[0.2em] uppercase text-neutral-500 mb-4">Company</p>
            <ul className="space-y-2 text-neutral-300 text-sm">
              <li>About</li>
              <li>Contact</li>
              <li>Sustainability</li>
            </ul>
          </div>

          <div className="md:col-span-3">
            <p className="text-xs tracking-[0.2em] uppercase text-neutral-500 mb-4">Contact</p>
            <ul className="space-y-2 text-neutral-300 text-sm">
              <li>wc2389@yahoo.com</li>
              <li>(417) 691-3178</li>
              <li>Mon–Sat · 8am–7pm</li>
            </ul>
          </div>
        </div>

        <div className="mt-16 pt-6 border-t border-neutral-800 flex flex-col md:flex-row justify-between gap-4 text-xs text-neutral-500">
          <p>© {new Date().getFullYear()} ToteHaul, Inc. All rights reserved.</p>
          <div className="flex gap-6">
            <span>Terms</span>
            <span>Privacy</span>
            <span>Service Areas</span>
          </div>
        </div>
      </div>
    </footer>
  );
};
